export enum ExchangeItemType {
	Money = 'money',
	House = 'house',
	Vehicle = 'vehicle',
	NumberPlate = 'numberPlate',
}

export interface IExchangeItem {
	id: string;
	type: ExchangeItemType;
	amount: number;
	isStackable: boolean;
}
